module.exports = __webpack_public_path__ + "static/media/slide1.377e6b70.jpg";